
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">Thông Tin Khác</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{$t(`customer.description`)}}</label>
              <button type="button" class="btn btn-default btn-xs" @click="onToggleDescription" v-if="!editable"><i class="fa fa-pencil"></i></button>
              <textarea type="text" rows="8" class="form-control" :placeholder="$t('customer.description')" v-model="description" :disabled="!editable">
              </textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          @click="setDescription()"
          style="margin-right: 5px;"
          v-if="editable"
        >
          <span class="btn-label">
          <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{$t('common.save')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import utils from '@/lib/utils'
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
  name: "RegisterOtherInfoView",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      description: "",
      editable: false
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.getDescription()
      } else {
        // pass
      }
    },
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    ...mapActions([
      "GET_USER_DESC",
      "SET_USER_DESC"
    ]),
    getDescription: function() {
      this.GET_USER_DESC({id: this.id}).then(
        function(res) {
          this.description = res.description
          this.$emit('description', this.description);
        }.bind(this)
      )
    },
    setDescription: function() {
      this.SET_USER_DESC({id: this.id, data: {description: this.description}}).then(
        function(res) {
          this.description = res.description
          this.onToggleDescription()
        }.bind(this)
      )
    },
    onToggleDescription: function() {
      this.editable = !this.editable
    }
  },
  mounted() {
    this.getDescription()
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Customer/RegisterOtherInfoView.vue